import { ImageObject } from "@/modules/images";

import imageLogo from "@/content/_images/generic/logo.png";
import imageFigmaLondon from "@/content/_images/generic/figma_london.jpg";

const images: ImageObject = {
	"g/logo": {
		src: imageLogo,
		alt: "Jakub Staniszewski's Logo, a beanie and glasses"
	},
	"g/figma-london": {
		src: imageFigmaLondon,
		alt: "Jakub Staniszewski standing next to #FigmaInLondon 2022 banner"
	}
};

export default images;
